import actions from '@/store/modules/profile/actions.js'
import getters from '@/store/modules/profile/getters.js'
import mutations from '@/store/modules/profile/mutations.js'
import getDefaultState from '@/store/modules/profile/state.js'

export default {
  actions,
  getters,
  mutations,
  state: getDefaultState()
}
